export const WIDTH = 512;
export const HEIGHT = 384;
export const THUMB = '_thumb';
